import { NgModule } from '@angular/core';
import { FastActionBannerPageModule } from '@com-delta-idp/mnx-fast-action-banner-ui';
import { SmartModule as PartnersModule } from '@com-delta-idp/mnx-skymiles-partners';
import { RelatedLinksModule } from '@com-delta-idp/mnx-skymiles-shared';
import { SkeletonLoaderDirective } from '@com-delta-omnichannel/aura';
import { OffersModule } from '../../features';
import { EarnsComponent } from './earns.component';

@NgModule({
  declarations: [EarnsComponent],
  imports: [
    FastActionBannerPageModule,
    OffersModule,
    RelatedLinksModule,
    SkeletonLoaderDirective,
    PartnersModule
  ],
  exports: [EarnsComponent]
})
export class EarnsModule {}
